import QRCode from 'qrcode';

const __createQRCodeGenerator = (qrCodeLib = QRCode) => ({
  /**
   * Generates a QR code for TOTP (Time-based One-Time Password) setup
   * @param {string} email - The user's email address
   * @param {string} secretKey - The TOTP secret key
   * @returns {Promise<string>} A data URL containing the QR code image
   * @throws {Error} If QR code generation fails
   */
  async generateTOTPQRCode(email, secretKey) {
    const issuer = 'ChiroTouch';
    const accountName = encodeURIComponent(email);
    const encodedIssuer = encodeURIComponent(issuer);
    const otpauthUrl = `otpauth://totp/${accountName}?secret=${secretKey}&issuer=${encodedIssuer}`;

    try {
      const qrCodeDataUrl = await qrCodeLib.toDataURL(otpauthUrl, {
        errorCorrectionLevel: 'M',
        margin: 2,
        width: 200,
        color: {
          dark: '#000000', // (foreground)
          light: '#ffffff', // (background)
        },
      });
      return qrCodeDataUrl;
    } catch (error) {
      console.error('Error generating QR code:', error);
      throw new Error('Failed to generate QR code');
    }
  },
});

const { generateTOTPQRCode } = __createQRCodeGenerator();
export { generateTOTPQRCode };

// For testing only!
export { __createQRCodeGenerator };
